<div class="fav_wrap">
    <mat-dialog-content>
        <div class="header">
            <div class="rate-txt" *ngIf="data?.promptDetailsStored?.length == 1 || removeTab">Delete Prompt</div>
            <div class="rate-txt" *ngIf="data?.promptDetailsStored?.length > 1">Delete Prompt Chain</div>
            <div>
                <img role="button" class="close" (click)="onClose($event)" src="/assets/icons/Close.svg" alt="close"/>
            </div>
        </div>
        <div class="body">
            <h2>Delete</h2>
            <p *ngIf="data?.promptDetailsStored?.length == 1">Are you sure you want to permanently delete the drafted prompt '{{title}}'?</p>
            <p *ngIf="removeTab">Are you sure you want to permanently delete the drafted prompt '{{title}}'?</p>
            <p *ngIf="data?.promptDetailsStored?.length > 1">Are you sure you want to permanently delete this drafted prompt chain '{{title}}'?</p>
            <p>The action cannot be undone.</p>
        </div>
        <div class="btn-div">
            <app-button class="button" [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" (onClick)="onClose($event)"></app-button>
            <app-button class="button" [type]="'primary'" [buttonType]="'button'" [buttonText]="'Delete'" (onClick)="onDelete($event, promptId)"></app-button>
        </div>
    </mat-dialog-content>
</div>